import { useOnline } from '../pwa/useOnline';
import { OfflineScreen } from './OfflineScreen';

// Router errorElement for the top-level routes (routes.tsx). A render/navigation error
// can happen for two very different reasons — being offline (eg. an uncached lazy
// chunk failed to load) or a genuine bug while online — and those must never be
// conflated: claiming "no connection" for a real bug is a dishonest state (review
// finding, Task 16 fix). isOnline is live (useOnline), not a one-time check at throw
// time, so this always reflects current connectivity.
export function RouteErrorBoundary() {
  const isOnline = useOnline();
  if (!isOnline) return <OfflineScreen />;
  return (
    <main className="screen-form">
      <div className="retry-card">
        <p>Couldn&rsquo;t load this screen.</p>
        <button className="btn-primary" onClick={() => window.location.reload()}>
          Try again
        </button>
      </div>
    </main>
  );
}
